// extracted by mini-css-extract-plugin
export default {"left_side":"BannerComponent_left_side__YGBUV","left_text":"BannerComponent_left_text__CeKgJ"};